module.exports = __webpack_public_path__ + "assets/img/tg-member.e5393a36.png";